export default __webpack_public_path__ + "media/images/smallbar-5164e0251d9bf59fea3ff67d5f2b285a.png";